import { getLinksElement } from '@/components/layout/footer/LinkElement';

export const formatFooterColumns = (linkColumn, field) => {
	return new Array(4)
		.fill(0)
		.map((_, index) => getLinksElement(linkColumn?.[index]?.[field]))
		.filter((col) => col?.length > 0);
};

export const formatDisplayedColumns = (columns, isMobile, columnsStyle) => {
	const [columns1, columns2, columns3, columns4] = columns;

	return isMobile
		? [
				[columns1, columns2],
				[columns3, columns4],
			].map(([firstCol, secondCol], index) => (
				<div key={index} className={`col-6 ${columnsStyle ? columnsStyle : ''}`}>
					<ul>
						{firstCol} {secondCol}
					</ul>
				</div>
			))
		: columns.map((col, index) => (
				<div key={index} className={`col-3 ${columnsStyle ? columnsStyle : ''}`}>
					<ul>{col}</ul>
				</div>
			));
};

export const selectMobileOrDesktopClassName = (prefix, isMobile, styles) => {
	return `${prefix}${isMobile ? ' ' + styles.mobile : ''}`;
};

export const displayTitle = (title, titleClassName) => {
	return title ? (
		<div className={titleClassName} data-test-id="footer-title">
			{title}
		</div>
	) : null;
};

export const getValidClassName = (className, isMobile, styles) => {
	let result = { ...styles };
	if (className) {
		result = className;
	} else {
		result.title = selectMobileOrDesktopClassName(styles.title, isMobile, styles);
		result.columnLinks = selectMobileOrDesktopClassName(styles.columnLinks, isMobile, styles);
	}
	return result;
};
